import React from 'react';

const DateRangeDivider = () => {
  return (
    <span style={{
      paddingLeft: '15px',
      paddingRight: '15px',
      // width: '100%',
      textAlign: 'center',
    }}>~</span>
  );
};
export default DateRangeDivider;
